import * as api from "@/api/williams/project";
import { queryKeys } from "../../queryKeys";
import { useQuery } from "react-query";

export function useProjectAssociations(id: string) {
  return useQuery({
    queryKey: queryKeys.project.associations(id),
    queryFn: () => api.getProjectAssociations(id),
  });
}
